import { RootState } from '../types/types'
import { Reducer } from 'redux'
import { serviceReducer } from './service-reducer'
import { combineDefinedReducers, combineReducers, pipeDefinedReducers, wrapDefinedReducer } from '../lib/utility'
import { userReducer } from './user-reducer'
import { organizationReducer } from './organization-reducer'
import { toastsReducer } from './toasts-reducer'
import { accessReducer } from './access-reducer'
import { myReferralReducer } from './my-referral-reducer'
import { capTableReducer } from './captable-reducer'
import { Service } from '@src/service'
import { checklistReducer } from './checklist-reducer'
// Spec 017 — Universal Task Thread UI Sync (FR-013)
import { taskThreadsReducer } from './task-threads-reducer'

export const rootReducer = (service: Service, routerReducer: Reducer) =>
  wrapDefinedReducer(
    pipeDefinedReducers<any>([
      combineReducers<RootState>({
        router: routerReducer,
      }),
      combineDefinedReducers<RootState>({
        user: userReducer,
        organization: organizationReducer,
        access: accessReducer,
        toasts: toastsReducer,
        myReferral: myReferralReducer,
        capTable: capTableReducer,
        checklist: checklistReducer,
        taskThreads: taskThreadsReducer,
      }),
      serviceReducer(service),
    ])
  )
